function hexToHsl(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255
  const g = parseInt(hex.slice(3, 5), 16) / 255
  const b = parseInt(hex.slice(5, 7), 16) / 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h = 0,
    s
  const l = (max + min) / 2

  if (max === min) {
    h = s = 0
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6
        break
      case g:
        h = ((b - r) / d + 2) / 6
        break
      case b:
        h = ((r - g) / d + 4) / 6
        break
    }
  }

  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100),
  }
}

export function applyInstanceTheme(theme) {
  if (!theme?.primaryColor) return

  const hex = theme.primaryColor
  if (typeof hex !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(hex)) {
    console.warn(
      `[instanceTheme] invalid primaryColor "${hex}" — must be 6-digit hex`,
    )
    return
  }

  const { h, s, l } = hexToHsl(hex)
  const root = document.documentElement

  // Set Layer 2 theme vars — all color-mix() derived tokens (surfaces, borders,
  // brand tints, table states) cascade automatically from --primary.
  root.style.setProperty('--primary', hex)
  root.style.setProperty(
    '--primary-dark',
    `hsl(${h}, ${s}%, ${Math.max(l - 8, 10)}%)`,
  )
  root.style.setProperty(
    '--primary-darker',
    `hsl(${h}, ${s}%, ${Math.max(l - 16, 5)}%)`,
  )
  root.style.setProperty(
    '--primary-light',
    `hsl(${h}, ${Math.round(s * 0.6)}%, ${Math.min(l + 26, 90)}%)`,
  )

  // Bulma HSL components — Bulma doesn't cascade through CSS vars, must be set explicitly
  const onSchemeL = Math.min(l, 38)
  root.style.setProperty('--bulma-primary-h', h)
  root.style.setProperty('--bulma-primary-s', `${s}%`)
  root.style.setProperty('--bulma-primary-l', `${l}%`)
  root.style.setProperty('--bulma-primary-on-scheme-l', `${onSchemeL}%`)
  root.style.setProperty('--bulma-scheme-h', h)
}
